import React, { KeyboardEventHandler, ReactNode } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { UseFormProps } from 'react-hook-form/dist/types';

interface FormContainerProps {
  /** Контент */
  children: ReactNode;
  /** Идентификатор */
  id?: string;
  /** Название */
  name?: string;
  /** Стиль */
  className?: string;
  /** Событие при отправке формы. На вход подаются данные с полей, добавленных в форму */
  // eslint-disable-next-line
  onSubmit?: (data: Record<string, any>) => void;
  formConfig?: UseFormProps;
  onKeyDown?: KeyboardEventHandler<HTMLFormElement>;
}

export const FormContainer = ({
  children,
  id,
  name,
  className = 'form-horizontal css-form',
  onSubmit,
  formConfig,
  onKeyDown,
}: FormContainerProps) => {
  const methods = useForm(formConfig);
  const { handleSubmit } = methods;
  return (
    <FormProvider {...methods}>
      <form
        id={id}
        name={name}
        className={className}
        onSubmit={onSubmit && handleSubmit(onSubmit)}
        onKeyDown={onKeyDown}
        autoComplete="off"
      >
        {children}
      </form>
    </FormProvider>
  );
};
